export class RecalculateTargetInUSDEvent {
  abosAccountId: string;
  bitfinexAccountId: number;
  currency: string;
  amount: number;

  constructor(abosAccountId: string, bitfinexAccountId: number, currency: string, amount: number) {
    this.abosAccountId = abosAccountId;
    this.bitfinexAccountId = bitfinexAccountId;
    this.currency = currency;
    this.amount = amount;
  }
}
